<h2 mat-dialog-title class="titre2 text-white">{{ 'USERS_MANAGEMENT.SELECT_VIEWING_ENTITY' | translate }}</h2>
<mat-dialog-content>
  @if (entites.length > 1) {
    <mat-label class="dark:text-white">{{ 'USERS_MANAGEMENT.ENTITY' | translate }}</mat-label>
    <mat-select [(ngModel)]="entiteSelectionnee">
      @for (entite of entites; track entite) {
        <mat-option [value]="entite" class="dark:text-white">
          {{entite.nom}}
        </mat-option>
      }
    </mat-select>
  } @else {
    <div class="mb-4">
      <span class="block text-sm font-medium mb-1 dark:text-white">{{ 'USERS_MANAGEMENT.ENTITY' | translate
      }}:</span>
      <span class="block text-sm font-medium mb-1 dark:text-white">
        {{ entites[0].nom }}
      </span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="dialogRef.close()" type="button" class="mr-2 px-4 py-2 btn-secondary-novoo">
    {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
  </button>
  <button [disabled]="entites.length > 1 && !entiteSelectionnee" (click)="onSelectionnerEntite()" type="submit"
    class="px-4 py-2 btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
    {{ 'USERS_MANAGEMENT.SELECT' | translate }}
  </button>
</mat-dialog-actions>